import { Component } from "react";
import OverlayedButton from "./overlayed-button";

export default class Creatable extends Component {
  render() {
    return <OverlayedButton
      {...this.props}
      icon="plus"
      iconBorderColor="#007BFF"
      iconColor="#007BFF"
      tooltip={this.props.tooltip ?? `treat as ${this.props.caption.toLowerCase()}`}
    />
  }
}